export const isUserMessage = (msg) => String(msg?.role) === 'user';
export const isAssistantMessage = (msg) => String(msg?.role) === 'assistant';
export const msgContent = (msg) => String(msg?.content || '');

export const isAssistantError = (msg) =>
  isAssistantMessage(msg) &&
    (msg.submission_stage === 'error' ||
      (typeof msg.content === 'string' &&
        msg.content.trim().includes('We had trouble generating')));

export const isAssistantDone = (msg) =>
  isAssistantMessage(msg) && msgContent(msg).trim() && !isAssistantError(msg);

export const lastMessage = (messages) => {
  const arr = Array.isArray(messages) ? messages : [];
  return arr[arr.length - 1];
};

export const checkConsecutiveAssistantError = (messages) => {
  const msgs = Array.isArray(messages) ? messages : [];
  let prevAssistant = null;
  for (let i = msgs.length - 2; i >= 0; i -= 1) {
    if (isAssistantMessage(msgs[i])) {
      prevAssistant = msgs[i];
      break;
    }
  }
  const consecutive = prevAssistant != null && isAssistantError(prevAssistant);
  return {
    isConsecutiveError: consecutive,
    errorTurnKey: consecutive ? String(msgs.length - 1) : null,
  };
};

export const submitChatOnEnter = (event, { inputTarget, sendButtonTarget }) => {
  if (event.key !== 'Enter' || event.shiftKey || event.isComposing) return;
  event.preventDefault();
  if (!inputTarget || inputTarget.disabled) return;
  if (!sendButtonTarget || sendButtonTarget.disabled) return;
  inputTarget.closest('form')?.requestSubmit();
};
